import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const [storyExpanded, setStoryExpanded] = useState(false);
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: "0px"
  }} data-id="element-609" data-mp="38vu7s8uzq744">
      <div className="mx-auto max-w-3xl space-y-14" data-id="element-610" data-mp="2v0i0z33k8q6u">

        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-611" data-mp="2yxxp8vzq49vz">
          <p className="text-[12px] font-semibold uppercase tracking-[0.28em] text-[#C8A870] md:text-[13px]" data-id="element-612" data-mp="2bag0787ufpwp">
            Una historia que podría ser la tuya
          </p>
          <p className="mt-2 font-body text-[12px] italic text-foreground/50 md:text-[13px]" data-id="element-613" data-mp="2g6wr2a6fgidh">
            Historia ilustrativa
          </p>
        </motion.div>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium relative overflow-hidden p-6 md:p-10" style={{
        paddingTop: "20px"
      }} data-id="element-614" data-mp="27anqgs6prdpr">
          {/* Línea lateral */}
          <div className="absolute bottom-0 left-0 top-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-615" data-mp="hrb2d6h7g72" />

          <div className="pl-3 md:pl-6" data-id="element-616" data-mp="38wsvlg3asrxb">

            {/* Historia colapsable */}
            <div className={`relative overflow-hidden transition-[max-height] duration-500 ease-out ${storyExpanded ? 'max-h-[1400px]' : 'max-h-[330px]'}`} data-id="element-617" data-mp="33yrayqq84kjq">
              <div className="space-y-5 md:space-y-6" data-id="element-618" data-mp="3dvw08zfd8w4r">

                {/* Inicio */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-619" data-mp="2q61qiqqcfnoq">
                  Mónica tenía 49 años.
                  <br data-id="element-620" data-mp="2l65mwslk5y9p" />
                  Comía bien, caminaba y se acostaba temprano.
                </p>

                {/* Situación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-621" data-mp="p1zgwyi84dd7">
                  Pero hacía meses que algo no cerraba. Se despertaba cansada,
                  incluso después de dormir sus horas.
                </p>

                {/* Intentos previos */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-622" data-mp="64y0mhj7yqty">
                  Hizo lo que cualquiera haría: ajustó comidas, caminó más e
                  intentó dormir mejor.
                </p>

                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-623" data-mp="f4uucxkgufvv">
                  Y su cuerpo ya no respondía igual a lo que antes le
                  funcionaba.
                </p>

                {/* Insight */}
                <p className="pt-1 font-body text-[17px] font-medium italic leading-[1.6] text-[#F0E8D8] md:text-[19px]" data-id="element-624" data-mp="1vjmbgec5w0pv">
                  Hasta que entendió que no le faltaba esfuerzo. Le faltaba
                  orden: saber qué priorizar, cuándo y cómo sostenerlo.
                </p>

                {/* Divider */}
                <div className="divider-fine !mt-7 w-full" data-id="element-625" data-mp="1vx833xsu485l" />

                {/* H.E.R. */}
                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-626" data-mp="1rx7pughh2304">
                  Para eso existe H.E.R.
                  <br data-id="element-627" data-mp="1mymo2cmknb9k" />
                  21 días para organizar alimentación, movimiento y descanso,
                  con una guía clara para cada día.
                </p>

              </div>

              {/* Fade */}
              {!storyExpanded && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#120f0d] via-[#120f0d]/90 to-transparent" data-id="element-628" data-mp="18xtqfj0z4028" />}
            </div>

            {/* Toggle */}
            <div className="mt-5 flex justify-center" data-id="element-629" data-mp="33bupa3wiwn2b">
              <button type="button" onClick={() => setStoryExpanded(value => !value)} aria-expanded={storyExpanded} className="inline-flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C8A870] transition-opacity duration-300 hover:opacity-70" data-id="element-630" data-mp="33c32jwwk5ue1">
                <span data-id="element-631" data-mp="31dbhtr9g8cf0">
                  {storyExpanded ? 'Ocultar historia' : 'Leer la historia completa'}
                </span>

                <span className={`transition-transform duration-300 ${storyExpanded ? 'rotate-180' : ''}`} data-id="element-632" data-mp="35hj8vv3dq4ge">
                  ↓
                </span>
              </button>
            </div>
          </div>
        </motion.div>

      </div>
    </section>;
}